import React, { Suspense, useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";

import "./assets/styles/main.scss";
import { persistor, store } from "./store";
import Router from "./Router";
import { useI18Next } from "./i18next";
import { PersistGate } from "redux-persist/integration/react";
import { ApplicationState } from "./store";
import { UserState } from "./store/reducers/user-reducer";
import { useUserHooks } from "./hooks/user-hooks";

declare global {
	interface Window {
		GoogleAnalyticsObject?: any;
		ga?: any;
		gaData?: any;
		gaGlobal?: any;
		gaplugins?: any;
		google_tag_data?: any;
	}
}

function AppContent() {
	const { validateSession } = useUserHooks();
	const { isSessionValidating } = useSelector<ApplicationState, UserState>(
		(state) => state.user
	);

	useEffect(() => {
		// Validate session on app mount by calling Profile API
		// 200 → authenticated, 401 → not authenticated (guest)
		// This is the single source of truth for session state
		validateSession();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []); // Only run once on mount

	// Block route rendering until session validation completes
	if (isSessionValidating) {
		return null; // Loading state: validate in progress
	}

	return <Router />;
}

function App() {
	const { initTranslation } = useI18Next();

	initTranslation();
	return (
		<Suspense fallback="">
			<BrowserRouter>
				<Provider store={store}>
					<PersistGate loading={null} persistor={persistor}>
						<AppContent />
					</PersistGate>
				</Provider>
			</BrowserRouter>
		</Suspense>
	);
}

export default App;
